<template>
    <router-link :to="to" class="flex-1">
        <div
            class="group w-full h-32 flex-1 flex flex-col px-5 py-2 border border-gray-100 shadow-sm rounded-sm hover:shadow"
        >
            <h4 class="font-semibold text-base text-gray-700 uppercase tracking-wide">
                {{ label }}
            </h4>
            <span class="flex items-center flex-1 font-bold text-4xl text-blue-500">{{
                value
            }}</span>
            <span class="text-xs text-gray-400 group-hover:text-gray-900"
                ><strong class="font-bold">{{ inLast30Days }}</strong> in last 30 days</span
            >
        </div>
    </router-link>
</template>

<script>
export default {
    props: ['label', 'value', 'to', 'inLast30Days'],
}
</script>
